import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Divider, TextField, MenuItem, SelectField, RaisedButton,
  Card, CardText, CircularProgress,
  Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn,
  CardHeader, Paper, Dialog, FlatButton,
} from "material-ui";
import {
  BuscarPrestaciones, Loading, obtenerTiposAtencion,
  CambiarTipoAtencion, DescargExcelGlosas,
  GetPrestacionesExcel, ProcesarSolicitudMasiva, ObtenerSolicitudes, LoadingFile,
  GetSizeArchivo,
  GetPrestacionesExcelCompleto,
} from "./actions";
import {
  ObtenerCentrosAtencion, ObtenerTiposArancel, ObtenerTiposPrestacion,
  CambiarTipoArancel, CambiarCentroAtencion, CambiarTipoPrestacion,
  CambiarCodFonasa, ObtenerUsuariosPerfil, CambiarCodPrestacion,
  ObtenerDatosUsuario, GetNombreInstitucion,

} from "../../Global/actions";
import ErrorSnack from "../../ErrorSnack/view";
import styles from "../../styles/styles";
import apiConfig from "./../../../config/api";
import InfoSE from "./info";
import GrillaBusquedaSE from "../GrillaBusqueda/view";
import GrillaSolicitudesSE from "../GrillaSolicitudes/view";

import mainState from "../../Main/state";
import TablePaginationCustom from "../../TablePagination/view";
import PaginacionSE from "../PaginacionSE/view";

class FiltroBusquedaSE extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalEnvioExitoso: false,
      modalEnvioError: false,
    };
  }

  componentWillMount() {
    this.props.dispatch(ObtenerUsuariosPerfil(`${apiConfig.usuariosContraloria}`, 1));
    this.props.dispatch(ObtenerUsuariosPerfil(`${apiConfig.usuariosConvenios}`, 2));
    this.props.dispatch(ObtenerCentrosAtencion());
    this.props.dispatch(obtenerTiposAtencion());
    this.props.dispatch(ObtenerDatosUsuario());
    this.props.dispatch(GetNombreInstitucion());
    this.props.dispatch(GetSizeArchivo());
  }

  componentDidMount() {
  }

  /** **************** VIEW GRILLA BUSQUEDA **************** * */
  ExportarExcel = () => {
    this.props.dispatch(LoadingFile(true));
    this.props.dispatch(GetPrestacionesExcel());
  }

  ExportarExcelCompleto = () => {
    this.props.dispatch(LoadingFile(true));
    this.props.dispatch(GetPrestacionesExcelCompleto());
  }

  DescargExcelGlosas = () => {
    this.props.dispatch(DescargExcelGlosas());
  }

  UploadSolicitud = (file) => {
    if (file) {
      const sizeArchivo = this.props.sizeArchivo[0].Descripcion;
      //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> size archivo >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
      //console.log(parseInt(sizeArchivo));
      this.props.dispatch(ProcesarSolicitudMasiva(
        parseInt(sizeArchivo),
        file,
        () => {
          this.setState({ modalEnvioExitoso: true });
          //this.props.dispatch(ObtenerSolicitudes());
          this.txt_file_solicitudespecial.value = "";
        },
        () => { this.setState({ modalEnvioError: true }); }
      ));
    }
  }
  /** **************** VIEW GRILLA BUSQUEDA **************** * */

  CambiarTipoArancel = (event, index, value) => {
    this.props.dispatch(CambiarTipoArancel(value));
  }

  CambiarCentroAtencion = (event, index, value) => {
    this.props.dispatch(CambiarCentroAtencion(value));
    this.props.dispatch(ObtenerTiposPrestacion(value));
    this.props.dispatch(ObtenerTiposArancel(value));
  }

  CambiarTipoPrestacion = (event, index, value) => {
    this.props.dispatch(CambiarTipoPrestacion(value));
  }

  CambiarCodFonasa = (event) => {
    const re = /^[0-9;]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      this.props.dispatch(CambiarCodFonasa(event.target.value));
    }
  }

  CambiarCodPrestacion = (event) => {
    this.props.dispatch(CambiarCodPrestacion(event.target.value));
  }

  CambiarTipoAtencion = (event, index, value) => {
    this.props.dispatch(CambiarTipoAtencion(value));
  }

  BuscarPrestaciones = () => {
    this.props.dispatch(Loading(true));
    this.props.dispatch(BuscarPrestaciones());
  }

  DescargExcelGlosas = () => {
    this.props.dispatch(DescargExcelGlosas());
  }

  callbackFunction = (childData) => {
    // console.log("CHILD DATA EN CONSULTA ARANCEL DETALLLE SE: ", childData);
    // this.sendData(childData);
  }

  render() {
    /** **************** VIEW GRILLA BUSQUEDA **************** * */
    const menuListprestaciones = [];
    if (this.props.prestaciones) {
      this.props.prestaciones.map((row, index) => (
        menuListprestaciones.push((
          <TableRow key={index}>
            <TableRowColumn style={styles.datoTablaBusqueda1}>{row.COD_PRESTADOR}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaBusqueda2} title={row.GLOSA_CODPRESTADOR}>{row.GLOSA_CODPRESTADOR}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaBusqueda3}>{row.COD_ISAPRE}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaBusqueda4}>{row.PROF_CCOD}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaBusqueda5}>{row.UNIDAD === "PE" ? "$" : ""} {row.VALOR}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaBusqueda7}>{row.UNIDAD === "VE" ? "VF" : row.UNIDAD}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaBusqueda6}>{row.TIPO_ATENCION}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaBusqueda8}>{(new Date(row.INICIO_VIG)).toLocaleDateString("en-GB", { timeZone: "UTC" })}</TableRowColumn>
            <TableRowColumn style={styles.datoTablaBusqueda9}>{row.CENTRO_AT}</TableRowColumn>
          </TableRow>
        ))
      ));
    }
    /** **************** VIEW GRILLA BUSQUEDA **************** * */

    const menuListTipoArancel = [];
    if (this.props.tiposArancel) {
      this.props.tiposArancel.forEach((element) => {
        menuListTipoArancel.push(<MenuItem key={element.Rut} value={element.Rut} primaryText={element.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const menuListCentroAtencion = [];
    if (this.props.centrosAtencion) {
      this.props.centrosAtencion.forEach((element) => {
        menuListCentroAtencion.push(<MenuItem key={element.Secuencia} value={element.Secuencia} primaryText={element.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const menuListTipoPrestaciones = [];
    if (this.props.tiposPrestaciones) {
      this.props.tiposPrestaciones.forEach((element) => {
        if (element.Id > 0) {
          menuListTipoPrestaciones.push(<MenuItem key={element.Id} value={element.Id} primaryText={`${element.TipoAtencion}: ${element.Descripcion}`} style={styles.customWidthItem} />);
        } else {
          menuListTipoPrestaciones.push(<MenuItem key={element.Id} value={element.Id} primaryText={element.Descripcion} style={styles.customWidthItem} />);
        }
      });
    }

    const menuListTipoAtencion = [];
    menuListTipoAtencion.push(<MenuItem key="0" value="0" primaryText="Todas" style={styles.customWidthItem} />);
    if (this.props.tiposAtencion) {
      this.props.tiposAtencion.forEach((element) => {
        menuListTipoAtencion.push(<MenuItem key={element.Simbolo} value={element.Simbolo} primaryText={element.Descripcion} style={styles.customWidthItem} />);
      });
    }

    // eslint-disable-next-line no-return-assign
    return (
      <div>
        {/* <h1>COSA CARGADA {this.state.loadingElement}</h1> */}
        {this.props.token ?
          <div >
            <div style={styles.frameContenidoGeneral}>
              <Card zDepth={0} style={{ paddingBottom: 0 }}>
                <CardText style={{ paddingBottom: 0 }}>
                  <div className="row" style={{ paddingBottom: 0 }}>
                    <div className="contenido" style={{ margin: 0, padding: 0, width: 925 }}>
                      <div style={styles.h1}>Solicitudes Especiales</div>
                      <InfoSE />
                    </div>
                  </div>
                  {
                    this.props.centrosAtencion && this.props.centrosAtencion.length > 0 &&
                      this.props.tiposPrestaciones && this.props.tiposPrestaciones.length > 0 &&
                      this.props.tiposArancel && this.props.tiposArancel.length > 0 &&
                      this.props.tiposAtencion && this.props.tiposAtencion.length > 0 ?
                      (
                        <div>
                          <div className="row">
                            <div className="col-4" style={styles.colSelectFieldActualizar}>
                              <div style={styles.floatingClaseSelect}> Centro de Atención </div>
                              {
                                this.props.centrosAtencion && this.props.centrosAtencion.length > 0 ?
                                  <SelectField
                                    name="dd_fbse_centroAtencion"
                                    id="dd_fbse_centroAtencion"
                                    value={this.props.filtros.centroAtencion}
                                    onChange={this.CambiarCentroAtencion}
                                    labelStyle={styles.h4}
                                    underlineStyle={styles.underlineSelectField}
                                    style={styles.selectFiledStyle}
                                    iconStyle={styles.iconSelectField}
                                    menuItemStyle={styles.menuItemStyleSelectField}
                                    selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                                  >
                                    {menuListCentroAtencion}
                                  </SelectField>
                                  :
                                  <CircularProgress />
                              }
                            </div>
                            <div className="col-4" style={styles.colSelectFieldActualizar}>
                              <div style={styles.floatingClaseSelect}> Tipo de Prestación </div>
                              {
                                this.props.tiposPrestaciones && this.props.tiposPrestaciones.length > 0 ?
                                  <SelectField
                                    name="dd_fbse_tipoPrestacion"
                                    id="dd_fbse_tipoPrestacion"
                                    value={this.props.filtros.tipoPrestacion}
                                    onChange={this.CambiarTipoPrestacion}
                                    labelStyle={styles.h4}
                                    underlineStyle={styles.underlineSelectField}
                                    style={styles.selectFiledStyle}
                                    iconStyle={styles.iconSelectField}
                                    menuItemStyle={styles.menuItemStyleSelectField}
                                    selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                                  >
                                    {menuListTipoPrestaciones}
                                  </SelectField>
                                  :
                                  <CircularProgress />
                              }
                            </div>
                            <div className="col-4" style={styles.colSelectFieldActualizar}>
                              <div style={styles.floatingClaseSelect}> Tipo de Arancel </div>
                              {
                                this.props.tiposArancel && this.props.tiposArancel.length > 0 ?
                                  <SelectField
                                    name="dd_fbse_tipoArancel"
                                    id="dd_fbse_tipoArancel"
                                    value={this.props.filtros.tipoArancel}
                                    onChange={this.CambiarTipoArancel}
                                    labelStyle={styles.h4}
                                    underlineStyle={styles.underlineSelectField}
                                    style={styles.selectFiledStyle}
                                    iconStyle={styles.iconSelectField}
                                    menuItemStyle={styles.menuItemStyleSelectField}
                                    selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                                  >
                                    {menuListTipoArancel}
                                  </SelectField>
                                  :
                                  <CircularProgress />
                              }
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-4" style={styles.colSelectFieldActualizar}>
                              <div style={styles.floatingClaseSelect2}>Tipo de Atención</div>
                              {
                                this.props.tiposAtencion && this.props.tiposAtencion.length > 0 ?
                                  <SelectField
                                    name="dd_fbse_tipoAtencion"
                                    id="dd_fbse_tipoAtencion"
                                    value={this.props.filtros.tipoAtencion}
                                    onChange={this.CambiarTipoAtencion}
                                    labelStyle={styles.h4}
                                    underlineStyle={styles.underlineSelectField}
                                    style={styles.selectFiledStyle}
                                    iconStyle={styles.iconSelectField}
                                    menuItemStyle={styles.menuItemStyleSelectField}
                                    selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                                  >
                                    {menuListTipoAtencion}
                                  </SelectField>
                                  :
                                  <CircularProgress />
                              }
                            </div>
                            <div className="col-4" style={styles.colSelectFieldActualizar}>
                              <div style={styles.floatingClaseSelect2}> Código del Prestador </div>
                              <TextField
                                name="txt_fbse_codprestacion"
                                id="txt_fbse_codprestacion"
                                value={this.props.filtros.codPrestacion || ""}
                                onChange={this.CambiarCodPrestacion}
                                maxLength={15}
                                underlineStyle={styles.underlineSelectField}
                                inputStyle={styles.h4}
                                style={styles.selectFiledStyle}
                              />
                            </div>
                            <div className="col-4" style={styles.colSelectFieldActualizar}>
                              <div style={styles.floatingClaseSelect2}> Código Isapre/Fonasa </div>
                              <TextField
                                name="txt_fbse_codfonasa"
                                id="txt_fbse_codfonasa"
                                value={this.props.filtros.codFonasa || ""}
                                onChange={this.CambiarCodFonasa}
                                errorText=""
                                maxLength={15}
                                underlineStyle={styles.underlineSelectField}
                                inputStyle={styles.h4}
                                style={styles.selectFiledStyle}
                              />
                            </div>
                          </div>
                        </div>
                      )
                      :
                      (
                        <CircularProgress
                          style={{
                            display: "block",
                            marginLeft: "auto",
                            marginRight: "auto",
                            padding: "50px 50px 100px 50px",
                          }}
                        />
                      )
                  }

                  <div className="row float-right" style={{ paddingRight: 40 }}>
                    <div className="col-4">
                      <RaisedButton
                        onClick={this.DescargExcelGlosas}
                        label="Glosas"
                        secondary
                        labelStyle={{ fontSize: "11px" }}
                        overlayStyle={{ borderRadius: 5 }}
                        rippleStyle={{ borderRadius: 5 }}
                        style={{ width: "200px", borderRadius: 5, marginLeft: 20 }}
                        buttonStyle={{ borderRadius: 5 }}
                      />
                    </div>
                    <div className="col-8" style={styles.colBotonesActualizar}>
                      {!this.props.loading ?
                        <RaisedButton
                          label="Buscar"
                          onClick={this.BuscarPrestaciones}
                          secondary
                          labelStyle={{ fontSize: "11px" }}
                          overlayStyle={{ borderRadius: 5 }}
                          rippleStyle={{ borderRadius: 5 }}
                          style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                          buttonStyle={{ borderRadius: 5 }}
                          disabled={
                            !(this.props.centrosAtencion && this.props.centrosAtencion.length > 0 &&
                              this.props.tiposPrestaciones && this.props.tiposPrestaciones.length > 0 &&
                              this.props.tiposArancel && this.props.tiposArancel.length > 0 &&
                              this.props.tiposAtencion && this.props.tiposAtencion.length > 0)
                          }
                        />
                        :
                        <RaisedButton
                          label="Cargando ..."
                          secondary
                          labelStyle={{ fontSize: "11px" }}
                          overlayStyle={{ borderRadius: 5 }}
                          rippleStyle={{ borderRadius: 5 }}
                          style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                          buttonStyle={{ borderRadius: 5 }}
                        />
                      }
                    </div>
                  </div>
                </CardText>
              </Card>
            </div>

            <div className="row" style={{ padding: 10, margin: "50px 0px 0px 0px" }} >
              <div className="col-12">
                <Divider />
              </div>
            </div>

            {/* <GrillaBusquedaSE /> */}
            {/* Grilla Solicitudes SE   */}
            <div>
              <div style={{ padding: "5px" }}>
                <Card
                  initiallyExpanded
                  zDepth={0}
                >
                  <CardHeader
                    actAsExpander
                    showExpandableButton
                    iconStyle={{ height: 20, width: 20, color: "#212121" }}
                    style={{
                      paddingTop: "0px", paddingBottom: "0px", maxWidth: "1290px", overflow: "auto",
                    }}
                  >
                    <div style={styles.h1}>Resultado Búsqueda</div>
                  </CardHeader>
                  <CardText
                    expandable
                    style={{
                      paddingTop: "0px", paddingBottom: "0px", maxWidth: "990px", overflow: "auto",
                    }}
                  >
                    {!this.props.loading ?
                      <div>
                        {(!this.props.prestaciones || this.props.prestaciones.length === 0) ?
                          <span style={{ textAlign: "left" }}>
                            {this.props.loading == null ? "-" : "No se encontraron resultados"}
                          </span>
                          :
                          <div>
                            <PaginacionSE
                              parentCallback={this.callbackFunction}
                              idTabla="tablaBusquedaPrestacionesSE"
                              tipoArancel={this.props.tipoArancel}
                              rutInstitucion={this.props.rutInstitucion}
                              detalleArancel={this.props.arancelesDetalle}
                              isapre={this.props.isapre}
                              key="pag_tablaBodyBusquedaPrestaciones"
                              rowsPerPageDefault={5} // [5,10,15,20,25]
                              totalRows={menuListprestaciones.length}
                              pageDefault={1}
                              totalPagina={10}
                              idTableBody="tablaBodyBusquedaPrestacionesSE"
                              showRowsPerPage={false}
                              labelStyleBtnPage={{ fontSize: "11px" }}
                              overlayStyleBtnPage={{ borderRadius: 20 }}
                              rippleStyleBtnPage={{ borderRadius: 20 }}
                              buttonStyleBtnPage={{ borderRadius: 20 }}
                              styleBtnPage={{
                                paddingLeft: 0,
                                paddingRight: 0,
                                paddingTop: 0,
                                paddingBottom: 0,
                                height: 25,
                                width: "45px",
                                minWidth: "45px",
                                borderRadius: 20,
                                marginRight: 5,
                              }}

                              labelStyleRowsPerPage={styles.h4}
                              underlineStyleRowsPerPage={styles.underlineSelectField}
                              iconStyleRowsPerPage={styles.iconSelectField}
                              menuItemStyleRowsPerPage={styles.menuItemStyleSelectField}
                              selectedMenuItemStyleRowsPerPage={styles.selectedMenuItemSelectField}
                              styleRowsPerPage={styles.selectFiledStyle}
                            />
                          </div>
                        }

                      </div>
                      :
                      <CircularProgress />
                    }

                    <div>
                      <br></br>
                      <Paper zDepth={2} >
                        <br></br>
                        <div className="row justify-content-md-center">
                          <div className="col-4">
                            {
                              !this.props.loading ?
                                <RaisedButton
                                  onClick={this.ExportarExcel}
                                  label="(1) Descargar Resultado"
                                  secondary
                                  labelStyle={{ fontSize: "11px" }}
                                  overlayStyle={{ borderRadius: 5 }}
                                  rippleStyle={{ borderRadius: 5 }}
                                  style={{ width: "250px", borderRadius: 5, marginLeft: 20 }}
                                  buttonStyle={{ borderRadius: 5 }}
                                  disabled={
                                    !(this.props.centrosAtencion && this.props.centrosAtencion.length > 0 &&
                                      this.props.tiposPrestaciones && this.props.tiposPrestaciones.length > 0 &&
                                      this.props.tiposArancel && this.props.tiposArancel.length > 0 &&
                                      this.props.tiposAtencion && this.props.tiposAtencion.length > 0)
                                  }
                                />
                                :
                                <RaisedButton
                                  label="Cargando ..."
                                  secondary
                                  labelStyle={{ fontSize: "11px" }}
                                  overlayStyle={{ borderRadius: 5 }}
                                  rippleStyle={{ borderRadius: 5 }}
                                  style={{ width: "200px", borderRadius: 5, marginLeft: 20 }}
                                  buttonStyle={{ borderRadius: 5 }}
                                />
                            }
                          </div>
                          <div className="col-4">
                            {
                              !this.props.loading ?
                                <RaisedButton
                                  onClick={this.ExportarExcelCompleto}
                                  label="(2) Arancel Completo"
                                  secondary
                                  labelStyle={{ fontSize: "11px" }}
                                  overlayStyle={{ borderRadius: 5 }}
                                  rippleStyle={{ borderRadius: 5 }}
                                  style={{ width: "250px", borderRadius: 5, marginLeft: 20 }}
                                  buttonStyle={{ borderRadius: 5 }}
                                  disabled={
                                    !(this.props.centrosAtencion && this.props.centrosAtencion.length > 0 &&
                                      this.props.tiposPrestaciones && this.props.tiposPrestaciones.length > 0 &&
                                      this.props.tiposArancel && this.props.tiposArancel.length > 0 &&
                                      this.props.tiposAtencion && this.props.tiposAtencion.length > 0)
                                  }
                                />
                                :
                                <RaisedButton
                                  label="Cargando ..."
                                  secondary
                                  labelStyle={{ fontSize: "11px" }}
                                  overlayStyle={{ borderRadius: 5 }}
                                  rippleStyle={{ borderRadius: 5 }}
                                  style={{ width: "200px", borderRadius: 5, marginLeft: 20 }}
                                  buttonStyle={{ borderRadius: 5 }}
                                />
                            }
                          </div>
                          <div className="col-4">
                            {
                              !this.props.loading ?
                                <RaisedButton
                                  // onClick={this.ExportarExcel}
                                  containerElement="label"
                                  label="(3) Cargar Solicitud"
                                  secondary
                                  labelStyle={{ fontSize: "11px" }}
                                  overlayStyle={{ borderRadius: 5 }}
                                  rippleStyle={{ borderRadius: 5 }}
                                  style={{ width: "250px", borderRadius: 5, marginLeft: 20 }}
                                  buttonStyle={{ borderRadius: 5 }}
                                  disabled={
                                    !(this.props.centrosAtencion && this.props.centrosAtencion.length > 0 &&
                                      this.props.tiposPrestaciones && this.props.tiposPrestaciones.length > 0 &&
                                      this.props.tiposArancel && this.props.tiposArancel.length > 0 &&
                                      this.props.tiposAtencion && this.props.tiposAtencion.length > 0)
                                  }
                                >
                                  <input
                                    type="file"
                                    key="txt_file_solicitudespecial"
                                    name="txt_file_solicitudespecial"
                                    ref={(c) => { this.txt_file_solicitudespecial = c; }}
                                    style={{ display: "none" }}
                                    onChange={(e) => this.UploadSolicitud(e.target.files[0])}
                                    accept=".xlsx"
                                  />
                                </RaisedButton>
                                :
                                <RaisedButton
                                  label="Cargando ..."
                                  secondary
                                  labelStyle={{ fontSize: "11px" }}
                                  overlayStyle={{ borderRadius: 5 }}
                                  rippleStyle={{ borderRadius: 5 }}
                                  style={{ width: "200px", borderRadius: 5, marginLeft: 20 }}
                                  buttonStyle={{ borderRadius: 5 }}
                                />
                            }
                          </div>
                        </div>
                        <br></br>
                      </Paper>
                      <br></br>
                    </div>
                  </CardText>
                </Card>
              </div>

              <Dialog
                key="dialogSolEspecialEnProceso"
                id="dialogSolEspecialEnProceso"
                actions={[
                  <FlatButton label="Aceptar" onClick={() => { this.setState({ modalEnvioExitoso: false }); this.props.dispatch(ObtenerSolicitudes()); }}>
                  </FlatButton>]}
                modal
                open={this.state.modalEnvioExitoso}
                style={{ fontSize: "13px" }}
              >
                Se está validando el archivo enviado, esto puede tardar unos minutos.
                <br></br>
                Podrá ver el resultado de la validación en Archivos Enviados.
              </Dialog>


              <Dialog
                key="dialogSolEspecialEnProcesoError"
                id="dialogSolEspecialEnProcesoError"
                actions={[
                  <FlatButton label="Aceptar" onClick={() => { this.setState({ modalEnvioError: false }); this.props.dispatch(ObtenerSolicitudes()); }}>
                  </FlatButton>]}
                modal
                open={this.state.modalEnvioError}
                style={{ fontSize: "13px" }}
              >
                Hubo un error al enviar la solicitud. Favor intentar nuevamente.
              </Dialog>

            </div>

            {/* Grilla Solicitudes SE   */}

            <GrillaSolicitudesSE />

            {/*
            <Drawer
              width="100%"
              openSecondary
              open={this.props.modalInfoSolicitudesEspeciales}
              docked={false}
            >
              {(this.props.modalInfoSolicitudesEspeciales) ?
                <InfoSE />
                : null}
            </Drawer>
          */}

            <ErrorSnack />
          </div>
          :
          null}

      </div>
    );
  }
}

FiltroBusquedaSE.defaultProps = {
  loading: null,
};

FiltroBusquedaSE.propTypes = {
  loading: PropTypes.bool,
  rutInstitucion: PropTypes.number.isRequired,
  tiposArancel: PropTypes.array.isRequired,
  centrosAtencion: PropTypes.array.isRequired,
  tiposPrestaciones: PropTypes.array.isRequired,
  tiposAtencion: PropTypes.array.isRequired,
  filtros: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  prestaciones: PropTypes.array.isRequired,
  loadingFile: PropTypes.bool.isRequired,
  sizeArchivo: PropTypes.any.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.filtroBusquedaSE.loading,
  rutInstitucion: state.global.rutInstitucion,
  tiposArancel: state.global.filtros_CAT.tiposArancel,
  centrosAtencion: state.global.filtros_CAT.centrosAtencion,
  tiposPrestaciones: state.global.filtros_CAT.tiposPrestaciones,
  tiposAtencion: state.filtroBusquedaSE.tiposAtencion,
  token: state.global.token,
  filtros: {
    tipoArancel: state.global.filtros_CAT.tipoArancel,
    centroAtencion: state.global.filtros_CAT.centroAtencion,
    tipoPrestacion: state.global.filtros_CAT.tipoPrestacion,
    codFonasa: state.global.filtros_CAT.codFonasa,
    codPrestacion: state.global.filtros_CAT.codPrestacion,
    tipoAtencion: state.filtroBusquedaSE.filtros.tipoAtencion,
  },
  prestaciones: state.filtroBusquedaSE.prestaciones,
  loadingFile: state.filtroBusquedaSE.loadingFile,
  sizeArchivo: state.filtroBusquedaSE.sizeArchivo,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(FiltroBusquedaSE);



// WEBPACK FOOTER //
// ./src/components/SolicitudesEspeciales/FiltroBusqueda/view.jsx